import { render } from "./app-modal-webhook-detail.vue?vue&type=template&id=3343fde0"
import script from "./app-modal-webhook-detail.vue?vue&type=script&lang=js"
export * from "./app-modal-webhook-detail.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/components/item/app-modal-webhook-detail.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3343fde0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3343fde0', __exports__)) {
    console.log('reload')
    api.reload('3343fde0', __exports__)
  }
  
  module.hot.accept("./app-modal-webhook-detail.vue?vue&type=template&id=3343fde0", () => {
    console.log('re-render')
    api.rerender('3343fde0', render)
  })

}


export default __exports__